import axios from 'axios';

const baseUrl = '/smartOrderRouting';

const smartRoutingConfigurationUrl = `${baseUrl}/configuration`;

const deleteProductWarehouseAssociations = `${baseUrl}/delete`;

export const updateConfiguration = async (configuration) => {
  try {
    const url = `${smartRoutingConfigurationUrl}`;
    const response = await axios.put(url, configuration);
    return response?.data ?? {};
  } catch (error) {
    throw new Error(`Error saving smart-routing rules rules: ${error?.message}`);
  }
};

export const deleteConfiguration = async () => {
  try {
    const url = `${deleteProductWarehouseAssociations}`;
    const response = await axios.post(url, {});
    return response?.data ?? {};
  } catch (error) {
    throw new Error(`Error deleting smart-routing rules rules: ${error?.message}`);
  }
};
